import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"

// GET /api/v1/messages/types
export const fetchMessageTypes = createAsyncThunk(
  "messageTypes/fetch",
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const token = state.auth?.token

      if (!token) {
        throw new Error("Authentication required")
      }

      const data = await get("messages/types")
      return data // array of strings
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch message types")
    }
  }
)

const initialState = {
  types: [],        // ["POSTS", "REPLY", ...]
  status: "idle",
  error: null,
}

const messageTypesSlice = createSlice({
  name: "messageTypes",
  initialState,
  reducers: {
    clearMessageTypes: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessageTypes.pending, (state) => {
        state.status = "loading"
      })
      .addCase(fetchMessageTypes.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.types = action.payload || []
      })
      .addCase(fetchMessageTypes.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { clearMessageTypes } = messageTypesSlice.actions
export default messageTypesSlice.reducer
